// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KU2Zs","colBig":"styles_colBig__1G4rQ","colSmall":"styles_colSmall__31ldj","shopifyNameWrapper":"styles_shopifyNameWrapper__2HpTl"};